/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

export const LogoSvg = ({
	alt,
	isDisabled = false,
	className,
	size = 24,
}: {
	alt: string;
	isDisabled?: boolean;
	/**
	 * @deprecated
	 * AI Logo no longer has a gradient
	 */
	colorStart?: string;
	/**
	 * @deprecated
	 * AI Logo no longer has a gradient
	 */
	colorStop?: string;
	className?: string;
	size?: number;
}) => {
	const stroke = isDisabled
		? token('color.icon.disabled', '#091E424F')
		: token('color.icon', '#44546F');

	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			stroke={stroke}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
			role={alt === '' ? 'presentation' : undefined}
		>
			{alt && <title>{alt}</title>}
			<path d="M14.5 14.5L17.5 17.5" strokeWidth="1.5" strokeLinecap="square" />
			<path d="M9.5 14.5L6.5 17.5" strokeWidth="1.5" strokeLinecap="square" />
			<path d="M9.5 9.5L6.5 6.5" strokeWidth="1.5" strokeLinecap="square" />
			<path d="M14.5 9.5L17.5 6.5" strokeWidth="1.5" strokeLinecap="square" />
			<path d="M12.0001 16V19" strokeWidth="1.5" />
			<path d="M8.00012 12L5.00012 12" strokeWidth="1.5" />
			<path d="M12.0001 8.00002L12.0001 4.99999" strokeWidth="1.5" />
			<path d="M16.0002 12L19.0002 12" strokeWidth="1.5" />
		</svg>
	);
};
